// @flow
import { fetchQuery } from 'react-relay';
import modernEnvironment from '../../lib/RelayUtils';
import { articleQuery } from '../../queries';
import * as ArticleEditMutation from '../../mutations/ArticleEditMutation';

export const articleEdit = (id: string, section: string, mutation, success) => {
	fetchQuery(modernEnvironment, articleQuery, { id: id, section }).then(response => {
		const { viewer } = response;
		if (viewer.article) {
			const input = { ...viewer.article };
			input.topics = viewer.article.topics.map(topic => topic.id);
			mutation(input);
			ArticleEditMutation.commit(modernEnvironment, input, () => {
				if (success) {
					success();
				}
			});
		}
	});
};



// WEBPACK FOOTER //
// src/components/articles/edit.util.js